import { Transition, Variants } from 'motion/react'

const expoEase: Transition['ease'] = [0.22, 1, 0.36, 1]

export const revealViewport = {
  once: true,
  amount: 0.25
}

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 28 },
  visible: (index = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: expoEase,
      delay: index * 0.08
    }
  })
}

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.55,
      ease: expoEase
    }
  }
}

export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.04
    }
  }
}
